export const carouselItems = [
  {
    id: 1,
    tag: '本周热门',
    title: '《我独自升级》第二季震撼归来',
    desc: '程肖宇从最弱猎人成长为最强觉醒者，暗影军团全面觉醒，全新篇章开启史诗级战斗。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20illustration%20featuring%20a%20powerful%20warrior%20with%20dark%20shadow%20army%20behind%20him%2C%20dramatic%20lighting%2C%20intense%20action%20pose%2C%20anime%20art%20style%20with%20vibrant%20colors%20and%20dynamic%20composition%2C%20clean%20background%20with%20energy%20effects&width=800&height=450&seq=manga-carousel-01&orientation=landscape',
    badge: '连载中',
  },
  {
    id: 2,
    tag: '新作上架',
    title: '《剑尊归来》华语武侠巅峰之作',
    desc: '一代剑尊重生少年时代，以绝世剑术横扫天下，恩怨情仇交织的武侠史诗。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manga%20illustration%20of%20a%20swordsman%20in%20traditional%20robes%20standing%20on%20a%20mountain%20peak%20with%20sword%20glowing%2C%20anime%20style%2C%20dramatic%20clouds%20and%20moonlight%2C%20vibrant%20colors%2C%20epic%20atmosphere&width=800&height=450&seq=manga-carousel-02&orientation=landscape',
    badge: '新作',
  },
  {
    id: 3,
    tag: '独家推荐',
    title: '《全知读者视角》剧情神作',
    desc: '唯一读完末世小说的人，在小说变成现实的瞬间，凭借全知视角展开生存博弈。',
    image: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20manga%20illustration%20featuring%20a%20smart%20protagonist%20reading%20a%20glowing%20book%20in%20a%20destroyed%20cityscape%2C%20anime%20art%20style%2C%20warm%20golden%20light%20from%20the%20book%2C%20dramatic%20atmosphere%2C%20vibrant%20colors&width=800&height=450&seq=manga-carousel-03&orientation=landscape',
    badge: '推荐',
  },
  {
    id: 4,
    tag: '韩漫精选',
    title: '《入赘骑士》逆袭复仇爽文',
    desc: '被家族抛弃的私生子，以赘婿身份卧薪尝胆，最终觉醒圣骑士血脉踏上复仇之路。',
    image: 'https://readdy.ai/api/search-image?query=Medieval%20fantasy%20knight%20manga%20illustration%20with%20a%20noble%20warrior%20in%20shining%20armor%20holding%20a%20glowing%20sword%2C%20castle%20background%2C%20anime%20art%20style%2C%20dramatic%20golden%20light%2C%20vibrant%20heroic%20atmosphere&width=800&height=450&seq=manga-carousel-04&orientation=landscape',
    badge: '热门',
  },
  {
    id: 5,
    tag: '日漫经典',
    title: '《咒术回战》涩谷事变篇',
    desc: '五条悟被封印，咒术界陷入前所未有的危机，虎杖与伙伴们面临终极考验。',
    image: 'https://readdy.ai/api/search-image?query=Supernatural%20battle%20manga%20illustration%20featuring%20a%20sorcerer%20with%20glowing%20cursed%20energy%20surrounded%20by%20dark%20spirits%2C%20urban%20Tokyo%20night%20background%2C%20anime%20art%20style%2C%20intense%20red%20and%20black%20color%20scheme&width=800&height=450&seq=manga-carousel-05&orientation=landscape',
    badge: '连载中',
  },
  {
    id: 6,
    tag: '国漫之光',
    title: '《一人之下》异人世界传奇',
    desc: '张楚岚卷入异人界的纷争，甲申之乱的真相逐渐浮出水面，异能大战一触即发。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manga%20illustration%20of%20a%20young%20man%20using%20mystical%20energy%20powers%20in%20a%20traditional%20Chinese%20village%20setting%2C%20anime%20style%2C%20flowing%20qi%20energy%20effects%2C%20vibrant%20green%20and%20gold%20colors&width=800&height=450&seq=manga-carousel-06&orientation=landscape',
    badge: '推荐',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '我独自升级',
    category: '韩漫·奇幻',
    desc: '最弱猎人逆袭成为最强觉醒者',
    image: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20style%20featuring%20a%20powerful%20dark%20haired%20hunter%20with%20glowing%20blue%20eyes%20and%20shadow%20powers%2C%20anime%20illustration%2C%20dark%20background%20with%20purple%20energy%2C%20clean%20composition&width=400&height=560&seq=manga-card-01&orientation=portrait',
    rating: '9.6',
    tag: '热门',
    chapters: '199话',
  },
  {
    id: 2,
    title: '剑尊归来',
    category: '国漫·武侠',
    desc: '重生少年以绝世剑术横扫天下',
    image: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20featuring%20a%20young%20swordsman%20in%20flowing%20white%20robes%20holding%20a%20gleaming%20sword%2C%20anime%20style%2C%20mountain%20and%20moon%20background%2C%20elegant%20and%20powerful%20atmosphere&width=400&height=560&seq=manga-card-02&orientation=portrait',
    rating: '9.4',
    tag: '新作',
    chapters: '86话',
  },
  {
    id: 3,
    title: '全知读者视角',
    category: '韩漫·末世',
    desc: '唯一知晓剧情的人改变世界命运',
    image: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20of%20a%20bespectacled%20man%20reading%20a%20mysterious%20glowing%20book%2C%20apocalyptic%20city%20silhouette%20behind%20him%2C%20anime%20illustration%20style%2C%20warm%20light%20contrast%2C%20clean%20design&width=400&height=560&seq=manga-card-03&orientation=portrait',
    rating: '9.7',
    tag: '推荐',
    chapters: '230话',
  },
  {
    id: 4,
    title: '咒术回战',
    category: '日漫·战斗',
    desc: '咒术师与诅咒的生死较量',
    image: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20featuring%20a%20spiky%20haired%20sorcerer%20with%20red%20energy%20surrounding%20his%20fist%2C%20anime%20style%2C%20dark%20urban%20background%20with%20cursed%20spirits%2C%20intense%20action%20pose&width=400&height=560&seq=manga-card-04&orientation=portrait',
    rating: '9.5',
    tag: '热门',
    chapters: '271话',
  },
  {
    id: 5,
    title: '入赘骑士',
    category: '韩漫·奇幻',
    desc: '赘婿觉醒圣骑士血脉逆袭复仇',
    image: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20of%20a%20handsome%20knight%20with%20silver%20armor%20and%20a%20radiant%20holy%20sword%2C%20anime%20style%2C%20castle%20interior%20background%2C%20golden%20divine%20light%2C%20noble%20atmosphere&width=400&height=560&seq=manga-card-05&orientation=portrait',
    rating: '9.2',
    tag: '连载',
    chapters: '145话',
  },
  {
    id: 6,
    title: '一人之下',
    category: '国漫·异能',
    desc: '异人世界的秘密与甲申真相',
    image: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20featuring%20a%20young%20man%20with%20flowing%20qi%20energy%20around%20his%20hands%2C%20traditional%20Chinese%20clothing%2C%20anime%20style%2C%20mystical%20forest%20background%2C%20vibrant%20green%20energy&width=400&height=560&seq=manga-card-06&orientation=portrait',
    rating: '9.3',
    tag: '推荐',
    chapters: '600+话',
  },
  {
    id: 7,
    title: '鬼灭之刃',
    category: '日漫·冒险',
    desc: '少年与鬼杀队的斩鬼之旅',
    image: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20of%20a%20young%20demon%20slayer%20with%20a%20nichirin%20sword%2C%20water%20breathing%20effects%2C%20anime%20style%2C%20moonlit%20night%20background%2C%20dynamic%20action%20composition&width=400&height=560&seq=manga-card-07&orientation=portrait',
    rating: '9.8',
    tag: '完结',
    chapters: '205话',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '2026年最值得期待的10部韩漫新作',
    desc: '独家盘点今年最受瞩目的韩国漫画，从奇幻到末世，总有一部适合你。',
    image: 'https://readdy.ai/api/search-image?query=Collage%20style%20illustration%20of%20various%20Korean%20manhwa%20characters%20in%20different%20genres%2C%20anime%20art%20style%2C%20vibrant%20colors%2C%20clean%20layout%20with%20text%20space%2C%20professional%20design&width=640&height=360&seq=manga-media-01&orientation=landscape',
    duration: '12:36',
    views: '32.8万',
  },
  {
    id: 2,
    title: '国漫崛起：从《镖人》到《一人之下》',
    desc: '深度解析国产漫画如何从模仿走向创新，打造属于中国的漫画宇宙。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20art%20style%20illustration%20showing%20traditional%20Chinese%20warriors%20and%20modern%20superpower%20users%20side%20by%20side%2C%20anime%20style%2C%20warm%20red%20and%20gold%20tones%2C%20epic%20composition&width=640&height=360&seq=manga-media-02&orientation=landscape',
    duration: '18:22',
    views: '25.6万',
  },
  {
    id: 3,
    title: '日漫经典回顾：那些年我们追过的神作',
    desc: '从《龙珠》到《鬼灭之刃》，回顾日本漫画黄金时代的经典作品。',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20Japanese%20manga%20montage%20illustration%20featuring%20iconic%20shonen%20characters%20from%20different%20eras%2C%20anime%20art%20style%2C%20warm%20sunset%20colors%2C%20emotional%20atmosphere&width=640&height=360&seq=manga-media-03&orientation=landscape',
    duration: '22:08',
    views: '41.2万',
  },
];

export const appData = {
  title: '拷贝漫画 APP',
  subtitle: '随时随地，畅享免费漫画阅读',
  desc: '支持 iOS 与 Android 双平台，高清画质、离线下载、智能推荐，千万漫迷的共同选择。',
  features: ['高清画质', '离线缓存', '智能推荐', '夜间模式', '书签同步', '无广告阅读'],
  qrImage: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20QR%20code%20design%20with%20manga%20themed%20decorative%20elements%20around%20the%20edges%2C%20minimalist%20style%2C%20white%20background%2C%20professional%20layout&width=240&height=240&seq=manga-app-qr&orientation=squarish',
  appImage: 'https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20showing%20a%20manga%20reading%20app%20interface%20with%20colorful%20manga%20covers%20displayed%2C%20modern%20UI%20design%2C%20clean%20layout%2C%20anime%20themed%20app&width=360&height=640&seq=manga-app-screen&orientation=portrait',
};

export const rankingItems = [
  { id: 1, rank: 1, title: '我独自升级', category: '韩漫·奇幻', heat: '985.6万', trend: 'up' },
  { id: 2, rank: 2, title: '鬼灭之刃', category: '日漫·冒险', heat: '967.3万', trend: 'stable' },
  { id: 3, rank: 3, title: '全知读者视角', category: '韩漫·末世', heat: '942.8万', trend: 'up' },
  { id: 4, rank: 4, title: '咒术回战', category: '日漫·战斗', heat: '918.5万', trend: 'down' },
  { id: 5, rank: 5, title: '剑尊归来', category: '国漫·武侠', heat: '876.2万', trend: 'up' },
  { id: 6, rank: 6, title: '一人之下', category: '国漫·异能', heat: '854.9万', trend: 'stable' },
];

export const updateItems = [
  { id: 1, time: '2分钟前', title: '《我独自升级》第200话更新', desc: '暗影军团大战巨龙，程肖宇展现全新觉醒技能。', tag: '最新' },
  { id: 2, time: '18分钟前', title: '《剑尊归来》第87话更新', desc: '剑尊以一敌百，武林大会震撼全场。', tag: '热更' },
  { id: 3, time: '35分钟前', title: '《入赘骑士》第146话更新', desc: '圣骑士血脉完全觉醒，王都震动。', tag: '热更' },
  { id: 4, time: '1小时前', title: '《全知读者视角》第231话更新', desc: '金独子揭露末世的终极真相。', tag: '推荐' },
  { id: 5, time: '2小时前', title: '《咒术回战》第272话更新', desc: '五条悟封印解开，史上最强决战开始。', tag: '热更' },
  { id: 6, time: '3小时前', title: '新作《狩龙者》正式上架', desc: '热血少年与龙族的史诗冒险正式开启。', tag: '新作' },
  { id: 7, time: '5小时前', title: '《一人之下》番外篇更新', desc: '宝儿姐的身世之谜有了新的线索。', tag: '推荐' },
];

export const topicItems = [
  { id: 1, name: '韩漫推荐', count: '3.2万讨论', color: 'primary' },
  { id: 2, name: '热血战斗', count: '2.8万讨论', color: 'accent' },
  { id: 3, name: '国漫崛起', count: '2.5万讨论', color: 'secondary' },
  { id: 4, name: '奇幻冒险', count: '2.1万讨论', color: 'accent' },
  { id: 5, name: '武侠修真', count: '1.9万讨论', color: 'primary' },
  { id: 6, name: '末世生存', count: '1.7万讨论', color: 'secondary' },
  { id: 7, name: '恋爱甜漫', count: '1.5万讨论', color: 'accent' },
  { id: 8, name: '悬疑推理', count: '1.3万讨论', color: 'primary' },
  { id: 9, name: '搞笑日常', count: '1.1万讨论', color: 'secondary' },
  { id: 10, name: '后宫逆袭', count: '0.9万讨论', color: 'accent' },
];

export const commentItems = [
  {
    id: 1,
    user: '漫迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20with%20spiky%20hair%2C%20friendly%20expression%2C%20simple%20colorful%20background%2C%20chibi%20art%20style&width=80&height=80&seq=manga-avatar-01&orientation=squarish',
    content: '拷贝漫画真的太好用了！每天通勤路上看几话，画质清晰加载快，韩漫资源特别全，推荐给所有喜欢看漫画的朋友。',
    manga: '我独自升级',
    time: '3天前',
    likes: 1286,
  },
  {
    id: 2,
    user: '樱花漫语',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20long%20pink%20hair%2C%20happy%20smile%2C%20pastel%20background%2C%20chibi%20art%20style&width=80&height=80&seq=manga-avatar-02&orientation=squarish',
    content: '从日漫转过来的，没想到国漫现在也这么好看！《剑尊归来》和《一人之下》都是神作，免费看太良心了。',
    manga: '剑尊归来',
    time: '5天前',
    likes: 953,
  },
  {
    id: 3,
    user: '深夜看漫人',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20boy%20avatar%20with%20glasses%2C%20calm%20expression%2C%20dark%20background%20with%20stars%2C%20chibi%20art%20style&width=80&height=80&seq=manga-avatar-03&orientation=squarish',
    content: '夜间模式真的舒服，晚上躺床上看漫画眼睛不累。更新速度也很快，基本跟韩网同步。唯一的缺点就是太好看了停不下来！',
    manga: '全知读者视角',
    time: '1周前',
    likes: 742,
  },
  {
    id: 4,
    user: '漫画收集控',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20twin%20tails%2C%20excited%20expression%2C%20colorful%20background%2C%20chibi%20art%20style&width=80&height=80&seq=manga-avatar-04&orientation=squarish',
    content: '收藏夹功能太实用了！我已经整理了十几个分类书单，每天都有新漫画上架，资源真的超级全，韩漫日漫国漫都有。',
    manga: '咒术回战',
    time: '1周前',
    likes: 618,
  },
];

export const aboutData = {
  title: '关于拷贝漫画',
  description: '拷贝漫画成立于2020年，是国内领先的免费漫画在线阅读平台。我们致力于为广大漫画爱好者提供最全面、最高清的漫画资源，覆盖韩漫、日漫、国漫等全类型漫画作品。',
  stats: [
    { value: '10万+', label: '漫画资源' },
    { value: '5000万+', label: '月活用户' },
    { value: '每日更新', label: '更新频率' },
    { value: '98%', label: '用户好评' },
  ],
  image: 'https://readdy.ai/api/search-image?query=Modern%20cozy%20reading%20space%20with%20a%20tablet%20displaying%20colorful%20manga%20pages%2C%20warm%20ambient%20lighting%2C%20bookshelf%20background%20with%20manga%20volumes%2C%20comfortable%20atmosphere%2C%20clean%20aesthetic&width=600&height=400&seq=manga-about-01&orientation=landscape',
};

export const faqItems = [
  {
    id: 1,
    question: '拷贝漫画是完全免费的吗？',
    answer: '是的，拷贝漫画平台上的所有漫画内容均免费向用户开放阅读。我们通过广告和品牌合作维持运营，用户无需支付任何费用即可畅读全站漫画资源，包括韩漫、日漫、国漫等所有类型。',
  },
  {
    id: 2,
    question: '支持哪些设备阅读漫画？',
    answer: '拷贝漫画支持 PC 网页端、iOS 和 Android 移动端。您可以通过浏览器访问我们的网站直接阅读，也可以下载拷贝漫画 APP 获得更好的移动阅读体验，支持离线下载和夜间模式。',
  },
  {
    id: 3,
    question: '漫画更新频率是怎样的？',
    answer: '我们与国内外多家漫画平台和作者保持紧密合作，热门连载漫画基本做到与官方同步更新。每日有数百部漫画获得更新，您可以关注喜欢的作品并开启更新提醒功能。',
  },
  {
    id: 4,
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的搜索功能直接搜索漫画名称，也可以按分类（韩漫、日漫、国漫）、标签（热血、奇幻、恋爱等）或排行榜浏览。我们还提供个性化推荐功能，根据您的阅读历史推荐相似作品。',
  },
  {
    id: 5,
    question: '阅读记录和收藏会保存吗？',
    answer: '会的。只要您登录账号，您的阅读历史、收藏夹、书签和评论都会自动同步到云端。换设备也不会丢失数据，随时随地从上次阅读的位置继续。',
  },
  {
    id: 6,
    question: '漫画画质怎么样？支持高清吗？',
    answer: '拷贝漫画所有作品均提供高清画质，部分热门作品还支持超清模式。我们采用智能图片压缩技术，在保证清晰度的同时优化加载速度，让您在手机流量环境下也能流畅阅读。',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '超过10万部漫画作品，涵盖韩漫、日漫、国漫等全类型，每日持续更新，满足各种阅读偏好。',
  },
  {
    id: 2,
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '支持PC、iOS、Android全平台阅读，阅读记录和收藏云端同步，换设备无缝衔接。',
  },
  {
    id: 3,
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全站高清漫画画质，智能压缩技术保证加载速度，带来沉浸式阅读体验。',
  },
  {
    id: 4,
    icon: 'ri-moon-line',
    title: '夜间模式',
    desc: '护眼夜间模式，深色背景柔和光线，长时间阅读不伤眼，夜间看漫画更舒适。',
  },
  {
    id: 5,
    icon: 'ri-download-2-line',
    title: '离线下载',
    desc: '支持漫画离线缓存，无网络也能畅快阅读，节省流量的同时随时随地想看就看。',
  },
];

export const contactData = {
  title: '联系我们',
  subtitle: '投稿、合作、反馈，期待您的来信',
  description: '如果您有漫画投稿需求、商务合作意向或任何使用建议，欢迎通过以下方式与我们联系。我们会在24小时内回复您的消息。',
  email: 'contact@copycomic.com',
  qq: '商务合作QQ：800123456',
  wechat: '微信公众号：拷贝漫画',
};

export const indexItems = [
  {
    id: 1,
    title: '热门韩漫',
    desc: '精选韩国人气漫画',
    icon: 'ri-fire-line',
    tags: ['我独自升级', '全知读者视角', '入赘骑士'],
  },
  {
    id: 2,
    title: '经典日漫',
    desc: '日本漫画黄金殿堂',
    icon: 'ri-sun-line',
    tags: ['鬼灭之刃', '咒术回战', '海贼王'],
  },
  {
    id: 3,
    title: '国漫之光',
    desc: '国产漫画佳作精选',
    icon: 'ri-china-railway-line',
    tags: ['剑尊归来', '一人之下', '镖人'],
  },
  {
    id: 4,
    title: '热血战斗',
    desc: '燃爆肾上腺的战斗漫画',
    icon: 'ri-sword-line',
    tags: ['咒术回战', '我独自升级', '龙珠超'],
  },
  {
    id: 5,
    title: '奇幻冒险',
    desc: '异世界与魔法之旅',
    icon: 'ri-compass-3-line',
    tags: ['全知读者视角', '转生史莱姆', '盾之勇者'],
  },
  {
    id: 6,
    title: '恋爱甜漫',
    desc: '甜蜜浪漫的心动故事',
    icon: 'ri-heart-line',
    tags: ['女神降临', '奶酪陷阱', '我的ID是江南美人'],
  },
  {
    id: 7,
    title: '武侠修真',
    desc: '中式玄幻与仙侠世界',
    icon: 'ri-magic-line',
    tags: ['剑尊归来', '凡人修仙传', '星辰变'],
  },
  {
    id: 8,
    title: '悬疑推理',
    desc: '烧脑反转的精彩故事',
    icon: 'ri-search-eye-line',
    tags: ['猪猡之王', '金钱游戏', '寄生虫'],
  },
];

export const headerNavItems = [
  { id: 'home', label: '首页', href: '#hero' },
  { id: 'index', label: '漫画分类', href: '#index' },
  { id: 'comments', label: '漫迷热评', href: '#comments' },
  { id: 'about', label: '关于我们', href: '#about' },
  { id: 'contact', label: '联系我们', href: '#contact' },
];

export const footerLinks = {
  categories: [
    { label: '韩漫', href: '#index' },
    { label: '日漫', href: '#index' },
    { label: '国漫', href: '#index' },
    { label: '热血', href: '#index' },
    { label: '奇幻', href: '#index' },
    { label: '恋爱', href: '#index' },
  ],
  help: [
    { label: '常见问题', href: '#faq' },
    { label: '阅读指南', href: '#about' },
    { label: 'APP下载', href: '#app' },
    { label: '用户协议', href: '#about' },
    { label: '隐私政策', href: '#about' },
  ],
  about: [
    { label: '关于我们', href: '#about' },
    { label: '联系我们', href: '#contact' },
    { label: '投稿合作', href: '#contact' },
    { label: '加入我们', href: '#contact' },
  ],
};